const getStyles = theme => ({
    button: {
        marginBottom: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    card: {
        maxWidth: 650,
    },
    dayWrapper: {
        position: 'relative',
        borderStyle: 'solid',
        borderWidth: '1px 0',
        borderColor: theme.palette.background.paper,
    },
    day: {
        width: 34,
        height: 34,
        fontSize: theme.typography.caption.fontSize,
        margin: '0 3px',
        color: 'inherit',
        padding: 0,
    },
    selectedDay: {
        background: theme.palette.primary.dark,
        borderRadius: '50%',
        '&:hover': {
            background: theme.palette.primary.main,
        },
    },
    lastDay: {
        background: theme.palette.primary.light,
        borderRadius: '50%',
        '&:hover': {
            background: theme.palette.primary.main,
        },
    },
    firstDay: {
        background: theme.palette.primary.light,
        borderRadius: '50%',
        '&:hover': {
            background: theme.palette.primary.main,
        },
    },
    nonCurrentMonthDay: {
        opacity: 0,
        pointerEvents: 'none',
    },
    highlight: {
        background: theme.palette.primary.light,
        color: theme.palette.common.white,
    },
    firstHighlight: {
        background: `linear-gradient(to right, rgba(0,0,0,0) 0%,rgba(0,0,0,0) 50%, ${theme.palette.primary.light} 50%, ${theme.palette.primary.light} 100%);`,
        color: theme.palette.common.white,
        borderTopLeftRadius: '50%',
        borderBottomLeftRadius: '50%',
    },
    endHighlight: {
        background: `linear-gradient(to left, rgba(0,0,0,0) 0%,rgba(0,0,0,0) 50%, ${theme.palette.primary.light} 50%, ${theme.palette.primary.light} 100%);`,
        color: theme.palette.common.white,
        borderTopRightRadius: '50%',
        borderBottomRightRadius: '50%',
    },
    highlightFirstAndLast: {
        background: 'transparent',
        color: theme.palette.common.white,
        borderTopRightRadius: '50%',
        borderBottomRightRadius: '50%',
    },
});

export default getStyles;
